export const firmwareAvailabilitiesLabels = {
  "up-to-date": "Up to Date",
  "update-scheduled": "Auto Update Schedule",
  "update-available": "Update Available",
  "new-firmware-available": "New Firmware Available"
}